const getEventSlugId = (eventId: string, eventSlug?: string) => `${eventSlug ? `${eventSlug}-` : ''}${eventId}`;

const eventUrl = ({
  eventId,
  eventSlug,
  relativeUrl = '',
}: {
  eventId: string;
  eventSlug?: string;
  relativeUrl?: string;
}) => `/events/${getEventSlugId(eventId, eventSlug)}${relativeUrl}`;

const communityUrl = ({ communitySlug, relativeUrl = '' }: { communitySlug: string; relativeUrl?: string }) =>
  `/communities/${communitySlug}${relativeUrl}`;

const circleUrl = ({
  eventId,
  eventSlug,
  circleId,
  relativeUrl = '',
  isMeeting = false,
}: {
  eventId: string;
  eventSlug?: string;
  circleId: string;
  relativeUrl?: string;
  isMeeting?: boolean;
}) => `${eventUrl({ eventId, eventSlug })}/${isMeeting ? 'meetings' : 'circles'}/${circleId}${relativeUrl}`;

const circleUrlCommunity = ({
  communitySlug,
  circleId,
  relativeUrl = '',
}: {
  communitySlug: string;
  circleId: string;
  relativeUrl?: string;
}) => `${communityUrl({ communitySlug })}/circles/${circleId}${relativeUrl}`;

const absoluteUrl = (relativeUrl: string) => `${window.location.origin}${relativeUrl}`;

const userUrl = (userId: string) => `/users/${userId}`;

const eventMatchTabUrl = ({ eventId, eventSlug }: { eventId: string; eventSlug?: string }) =>
  `${eventUrl({ eventId, eventSlug })}/match`;

const inviteUrl = ({ eventId, eventSlug, inviteeId }: { eventId: string; eventSlug?: string; inviteeId: string }) =>
  `${eventUrl({ eventId, eventSlug })}/meetings/invite/${inviteeId}`;

export { eventUrl, circleUrl, absoluteUrl, userUrl, communityUrl, circleUrlCommunity, inviteUrl, eventMatchTabUrl };
